import { Component, OnInit, Input, Injector } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalBaseComponent } from '../modal-base-component';

@Component({
  selector: 'app-generic-operation-modal',
  templateUrl: './generic-operation-modal.component.html',
  styleUrls: ['./generic-operation-modal.component.css']
})
export class GenericOperationModalComponent extends ModalBaseComponent implements OnInit {

  operationName: string;

  constructor(private inject: Injector, private _bsModalRef: BsModalRef) {
    super(inject);
  }

  ngOnInit() {
  }
  public closeModal(): void {
    this._bsModalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/generic-operation/generic-operation-modal.component.ts